import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio Call for Proposals" mdxType="Seo" />
    <h1 {...{
      "id": "call-for-proposals"
    }}>{`Call for Proposals`}</h1>
    <blockquote>
      <p parentName="blockquote">{`The CFP is now closed for PyOhio 2021. If you’d like to speak at a future PyOhio event, be sure to `}<a parentName="p" {...{
          "href": "/2021/about/newsletter"
        }}>{`subscribe to our newsletter`}</a>{` to keep up to date.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      